import FinanceApi from '@/services/FinanceApi';

const getAll = async (config) => {
    return FinanceApi.get('/raise/rates', config);
}

const get = async (id) => {
    return FinanceApi.get('/raise/rates/' + id);
}

const store = async (data) => {
    if (data.id) {
        return FinanceApi.put('/raise/rates/' + data.id, data);
    }
    return FinanceApi.post('/raise/rates', data);
}

const update = async (id, formData) => {
    return FinanceApi.put('/raise/rates/' + id, formData);
}

const del = async (code) => {
    return FinanceApi.delete('/raise/rates/' + code);
}

export default {
    getAll,
    get,
    store,
    update,
    del
}
